export default {
    row1: [
        {
            column: "column1",
            columnWidth: "50%",

            rows: { //customHouse
                row1: [
                    {
                        name: "customHouse",
                        label: "customHouse",
                        component: "text-field",
                        type: "autocomplete",
                        endpoint: "getCustomeHouse",
                        endPointWithId: "getDrawBackByCustomHouseIdQuery",
                        autofillTargets: {
                            customDetailsDrawbackEntityName: "customDetailsDrawbackEntityName",
                            customDetailsDrawbackAddress: "customDetailsDrawbackAddress",
                            customDetailsDrawbackACNo: "customDetailsDrawbackACNo",
                            customDetailsDrawbackLedgerNo: "customDetailsDrawbackLedgerNo",
                            customDetailsDrawbackAcnoEpi: "customDetailsDrawbackAcnoEpi",
                            deletedrawback: "customDetailsDrawbackId"

                        }
                    },
                    {

                        name: "delete",
                        label: "Delete",
                        component: "outlinebutton",
                        action: "deleteFormdata",
                        sx: {
                            mt: "32px",
                        },

                    },
                    {

                        name: "deletedrawback",


                    }

                ],

                row2: [

                    {
                        name: "customDetailsDrawbackEntityName",
                        label: "Entity Name",
                        component: "text-field",
                        Required: true,
                    },



                ],
                row3: [
                    {
                        name: "customDetailsDrawbackAddress",
                        label: "Name & Address Of Drawback Bank",
                        component: "text-field",
                        Required: true,
                    },


                ],
                row4: [
                    {
                        name: "customDetailsDrawbackACNo",
                        label: "A/C No.",
                        component: "text-field",
                    },

                ],
                row5: [
                    {
                        name: "customDetailsDrawbackLedgerNo",
                        label: "LedgerNumber",
                        component: "text-field",
                    },


                ],
                row6: [
                    {
                        name: "customDetailsDrawbackAcnoEpi",
                        label: "A/CNo.(EDI)",
                        component: "text-field",
                    },


                ],
            }
        }
    ]
}